import React, {useContext, useMemo, useRef} from 'react'
import _ from 'lodash'
import moment from 'moment'
import './PillRow.scss'
import Pill from './Pill'
import ApMath from '../../../../utils/ApMath'
import {ReservationContext} from '../../../../context/Reservation'
const PillRow = ({data, headers = {primary: [], secondary: []}, breakpoint = {}}) => {
  const {entityFields} = useContext(ReservationContext)
  const {events: dataEvents} = data

  // filter and format
  const pills = useMemo(() => {
    // exit if primary has no length
    if (headers.primary.length === 0) return []
    const first = headers.primary[0].sec
    const last = headers.primary[headers.primary.length - 1].endSec

    // filter data based on time
    let events =
      !_.isEmpty(dataEvents) &&
      dataEvents.filter(e => {
        const sd = new Date(e.start).setSeconds(0, 0).valueOf()
        const useNow =
          e.type === 'SystemReservationAction' && e.status === 'fulfilled' && e.states === 'overdue'
        const ed = useNow
          ? new Date().setSeconds(0, 0).valueOf()
          : new Date(e.action_return_date || e.action_values?.field_3 || e.end)
              .setSeconds(0, 0)
              .valueOf()

        e['__ed'] = ed

        return (
          (sd >= first && sd <= last) || (ed >= first && ed <= last) || (sd <= first && ed >= last)
        )
      })

    const getTitle = ev => {
      const start_date = moment(ev.start)
      let real_end = moment(ev.end)
      let title = ''
      let displayName = ''
      let reservationID = ' '

      if (ev?.raw?.reservation_uid !== undefined) {
        reservationID = `#${ev.raw.reservation_uid},`
      }
      if (
        ev.entity_object.display_name ||
        ev.entity_object.display_with_secondary ||
        ev.entity_object.display_name_third
      ) {
        displayName = `${reservationID} ${ev.entity_object.display_name &&
          ev.entity_object.display_name + ','} ${ev.entity_object.display_with_secondary &&
          ev.entity_object.display_with_secondary + ','} ${ev.entity_object.display_name_third &&
          ev.entity_object.display_name_third}`
      } else {
        if (ev.type === 'SystemReservationAction') {
          // TODO: add ev count
          title = `${reservationID} ${ev?.reserve_for?.value}, ${start_date.format(
            'MMMM Do'
          )} - ${real_end.format('MMMM Do')}`
        } else if (ev.type === 'ReservationAction') {
          title = `${ev?.entity_object?.display_name}, ${ev?.action?.name}, ${start_date.format(
            'MMMM Do'
          )} - ${real_end.format('MMMM Do')}`
        } else if (ev.type === 'DefaultAction') {
          title = `${ev?.entity_object?.display_name}, ${ev?.action?.name}, ${start_date.format(
            'MMMM Do'
          )}`
        } else {
          let field =
            ev.field ||
            entityFields?.find(f => {
              return f.field_id === ev.raw.field_id
            })
          title = `${ev?.entity_object?.display_name}, ${field?.name ||
            field?.field_name ||
            ''}, ${start_date.format('MMMM Do')}`
        }
      }
      if (displayName.length) {
        return displayName
      } else {
        return title
      }
    }
    // fix titles.
    events =
      !_.isEmpty(events) &&
      events.map(item => {
        const start_date = moment(item.start)
        const end_date = moment(item.end)

        let name = ''
        if (item?.entity_object?.display_field_present === true) {
          name = getTitle(item)
        } else {
          if (item.type === 'SystemReservationAction') {
            // TODO: add item count
            name = `#${item?.reservation_uid}, ${item?.reserve_for?.value}, ${start_date.format(
              'MMMM Do'
            )} - ${end_date.format('MMMM Do')}`
          } else if (item.type === 'ReservationAction') {
            name = `${item?.entity_object?.display_name}, ${
              item?.action?.name
            }, ${start_date.format('MMMM Do')} - ${end_date.format('MMMM Do')}`
          } else if (item.type === 'DefaultAction') {
            name = `${item?.entity_object?.display_name}, ${
              item?.action?.name
            }, ${start_date.format('MMMM Do')}`
          } else {
            let field =
              item.field ||
              entityFields?.find(f => {
                return f.field_id === item.raw.field_id
              })
            name = `${item?.entity_object?.display_name}, ${field?.name ||
              field?.field_name ||
              ''}, ${start_date.format('MMMM Do')}`
          }
        }
        // update overdue state
        if (
          item.type === 'SystemReservationAction' &&
          item.status === 'fulfilled' &&
          item.states === ''
        ) {
          if (end_date.diff(moment(), 'minutes') < 0) {
            // overdue
            item.action_return_date = moment() // TODO: replace this to more meaning full variable.. maybe overdue_date?
          }
        }

        return {...item, title: name}
      })

    // format
    // - group by header column
    // -- only 1 in group
    // let samp = [
    //   {start:"2020-09-01", end:"2020-09-20", title:"pill 1"},
    //   {start:"2020-09-20", end:"2020-09-30", title:"pill 2"},
    //   {start:"2020-10-01", end:"2020-11-30", title:"pill 3"},
    //   {start:"2020-10-01", end:"2020-10-20", title:"pill 4"},
    //   {start:"2020-12-01", end:"2021-01-20", title:"pill 5"},
    // ]
    // expected
    // (2 events)(2 events)(1 event)(pill 5         )

    // - (2 events) : pill 1, pill 2
    // - (2 events) : pill 3, pill 4
    // - (pill 3) : pill 3
    // - (pill 5         ) : pill 5

    // steps
    // - breakdown per column
    let groups = Array.from({length: headers.primary.length})
    _.each(events, ev => {
      const sd = new Date(ev.start).setSeconds(0, 0).valueOf()
      const ed = ev.__ed

      // iterate each headers
      _.each(headers.primary, (h, hi) => {
        if (ApMath.isRangeOverlap(sd, ed, h.sec, h.endSec)) {
          if (!groups[hi]) {
            groups[hi] = []
          }
          groups[hi].push(ev)
        }
      })
    })

    let _pills = []
    let singleEventPill = null
    // added 1 extra loop for checking singleEventPill
    for (let i = 0; i <= groups.length; i++) {
      // if null
      if (!groups[i]) {
        if (singleEventPill) {
          // push
          _pills.push({
            ...singleEventPill,
            width:
              ((singleEventPill.endSec - singleEventPill.startSec) /
                (headers.primary[i - 1].endSec - headers.primary[i - 1].sec)) *
              headers.primary[i - 1].width,
          })
          // and remove
          singleEventPill = null
        }
        continue
      }

      if (singleEventPill) {
        // ----> if events are same as previous: merge group current and group 2
        if (_.isEqual(_.sortBy(singleEventPill.data), _.sortBy(groups[i]))) {
          singleEventPill.endSec =
            groups[i].length > 1
              ? headers.primary[i].endSec
              : Math.min(headers.primary[i].endSec, groups[i][0].__ed)

          continue // next iteration
        }

        // ----> if events are different event as previous: terminate end and proceed to next column
        if (!_.isEqual(_.sortBy(singleEventPill.data), _.sortBy(groups[i]))) {
          // push singleEventPill
          _pills.push({
            ...singleEventPill,
            width:
              ((singleEventPill.endSec - singleEventPill.startSec) /
                (headers.primary[i - 1].endSec - headers.primary[i - 1].sec)) *
              headers.primary[i - 1].width,
          })
          // and create new
          singleEventPill = {
            label: groups[i].length > 1 ? `${groups[i].length} Events` : groups[i][0].title,
            startSec:
              groups[i].length > 1
                ? headers.primary[i].sec
                : Math.max(
                    headers.primary[i].sec,
                    new Date(groups[i][0].start).setSeconds(0, 0).valueOf()
                  ),
            endSec:
              groups[i].length > 1
                ? headers.primary[i].endSec
                : Math.min(headers.primary[i].endSec, groups[i][0].__ed),
            data: groups[i],
          }

          const colOffset =
            ((singleEventPill.startSec - headers.primary[i].sec) /
              (headers.primary[i].endSec - headers.primary[i].sec)) *
            headers.primary[i].width

          singleEventPill.colOffset = colOffset
          singleEventPill.colIndex = i
          singleEventPill.colRemainder = headers.primary[i].width - colOffset
          singleEventPill.left = colOffset + headers.primary[i].width * i
        }
      } else {
        // create new
        singleEventPill = {
          label: groups[i].length > 1 ? `${groups[i].length} Events` : groups[i][0].title,
          startSec:
            groups[i].length > 1
              ? headers.primary[i].sec
              : Math.max(
                  headers.primary[i].sec,
                  new Date(groups[i][0].start).setSeconds(0, 0).valueOf()
                ),
          endSec:
            groups[i].length > 1
              ? headers.primary[i].endSec
              : Math.min(headers.primary[i].endSec, groups[i][0].__ed),
          data: groups[i],
        }
        const colOffset =
          ((singleEventPill.startSec - headers.primary[i].sec) /
            (headers.primary[i].endSec - headers.primary[i].sec)) *
          headers.primary[i].width

        singleEventPill.colOffset = colOffset
        singleEventPill.colIndex = i
        singleEventPill.colRemainder = headers.primary[i].width - colOffset
        singleEventPill.left = colOffset + headers.primary[i].width * i
      }
    }
    return _pills
  }, [dataEvents, headers, entityFields])

  return (
    <div className="c-pill-row" data-x="date-selection" style={{'--hover-bg': `${data.color}55`}}>
      {_.map(pills, (ev, i) => (
        <Pill key={i} data={ev} headers={headers} breakpoint={breakpoint} />
      ))}
    </div>
  )
}

export default PillRow
